import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=318081ec"
import script from "./Viewer.vue?vue&type=script&lang=js"
export * from "./Viewer.vue?vue&type=script&lang=js"
import style0 from "./Viewer.vue?vue&type=style&index=0&id=318081ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports